import clsx from "classnames";
import { createUseStyles } from "react-jss";
import { isTV } from "../utils/platform";
import { useIsProfileSwitching } from "./useProfileSession";

const useStyles = createUseStyles({
  page: {
    transition: "opacity 320ms ease-in-out, transform 320ms ease-in-out",
  },
  switching: {
    opacity: 0.05,
    transitionDuration: "180ms",
    transitionTimingFunction: "ease-out",
    pointerEvents: "none",
  },
  slide: {
    transform: "translateY(8px)",
  },
});

export const useProfileSwitchFade = ({ slide = true } = {}) => {
  const classes = useStyles();
  const isSwitching = useIsProfileSwitching();
  if (isTV) return "";
  return clsx(
    classes.page,
    isSwitching && classes.switching,
    isSwitching && slide && classes.slide,
  );
};
